import React, { useState, useEffect, useRef } from 'react';

const PhotoCarousel = ({ photos, interval = 3800 }) => {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCurrent(c => (c + 1) % photos.length);
    }, interval);
    return () => clearInterval(timerRef.current);
  }, [photos.length, interval]);

  return (
    <div className="relative w-full h-full overflow-hidden rounded-sm shadow-xl border-4 border-brand-vintage ring-1 ring-brand-stone/20">
      {photos.map((src, i) => (
        <div
          key={i}
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${src}')`,
            opacity: i === current ? 1 : 0,
            transition: 'opacity 0.9s ease-in-out',
            willChange: 'opacity',
          }}
        />
      ))}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
        {photos.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            aria-label={`Photo ${i + 1}`}
            className={`h-1 rounded-full transition-all duration-500 ${i === current ? 'bg-brand-vintage w-6' : 'bg-brand-vintage/40 w-1.5'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default PhotoCarousel;